import Section from "@/components/ui/section";
import React from "react";
import MemberShort from "@/components/ui/member-short";
import Card from "@/components/ui/card";
export default function Team({ title, data, className }) {
  return (
    <Section className={className}>
      <h2 className="text-darkBlue">{title}</h2>
      {/* <div className="mt-8 grid grid-rows-auto lg:grid-cols-3 md:grid-cols-2 grid-cols-1 lg:gap-20 md:gap-8 gap-12">
        {data.map((member, key) => (
          <MemberShort data={member} key={"title" + key} />
        ))}
      </div> */}
      <div className="mt-8 grid grid-rows-auto lg:grid-cols-5 md:grid-cols-3 grid-cols-2 md:gap-8 gap-4">
        {data.map((member, key) => (
          <Card data={member} key={"title" + key} />
        ))}
      </div>
    </Section>
  );
}
